<template>
  <div>
    <div class="fix">
      <el-row :gutter="10">
        <el-col :span="18">
          <el-input v-model="names" placeholder="请输入姓名" clearable @change="handlerPageNo"></el-input>
        </el-col>
        <el-button type="primary" @click="search" class="pull-right mgr-0">搜索</el-button>
      </el-row>
    </div>
    <div class="table" v-show="flag">
      <el-table :data="tableData" border height="100%"  @current-change="handleCurrentChange" highlight-current-row>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="name" label="姓名" width="120"></el-table-column>
        <el-table-column prop="fictitiousFullName" label="组织全路径" min-width="120" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>

    <div class="tree" v-show="!flag">
      <el-tree
        v-loading="isLoading"
        :data="treeData"
        :props="orgProps"
        :load="load"
        node-key="id"
        ref="orgTree"
        lazy
        :highlight-current="true"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
  </div>
</template>

<script>
// import { SETTING_EMPLOYEE_ORG_FIND_TREE } from '@/store/mutation-types'

import {mapState} from "vuex";

export default {
  name: "EmployeeList",
  props: {},
  data() {
    return {
        names:'',
        flag:false,
        orgProps: {
        label: 'name',
        isLeaf: function(data){
          return !data.children
        }
      },
      treeData: [],
      isLoading: false,
      tableData: [],
      tableData1: [
             ],
      data1: "123"
    };
  },
  computed:{
    ...mapState("app",["currentUser"])

  },
  methods: {
        load({ level, data }, resolve) {
      this.isLoading = true
      /* 初始化第一级树节点 */
      if (level === 0) {
        this.$store.dispatch("funJurisdiction/findEmployOrgTree", {
          parentId: this.currentUser.tenancyCode
        }).then(result => {
          this.isLoading = false
          resolve(result)
        })
      } else {
        /* 获取树下级节点 */
        this.$store.dispatch("funJurisdiction/findEmployOrgTree", {
          parentId: data.id
        }).then(result => {
          this.isLoading = false
          resolve(result)
        })
      }
    },
        /* 监听树点击事件,并抛出 change 事件 */
    handleNodeClick(data) {
      this.$emit('change', data)
    },
    search() {
      let params={
        name:this.names
      }

      if (this.names!=="") {
          this.flag=true
        // this.tableData = this.tableData1;
         this.$store.dispatch('emJurisdiction/getEmployeeList',params).then((res)=>{
            this.tableData=res.page.result
      })
      }
    },
    handleCurrentChange(data){
        this.$emit('handChangeEmployee',data)
    },
    handlerPageNo(){

       if(this.names===""){
           console.log(this.name)
           this.flag=false
          //  this.$store.commit('emJurisdiction/setOrgData',this.tableData1)

       }
    }
  }
};
</script>

<style lang="scss" scoped>
// .fix{
//   display: fixed;
//   top: 5px;
// }
.table {
  // position:absolute;
  width: 100%;
  padding:30px 0px;
  height: calc(100% - 100px);
  // width: calc(100% - 100px) ;
}
.tree{
    position: absolute;
    top:40px;
    left:0;
    bottom:0;
    right: 0;
    max-height: 100%;
    padding: 10px 0px;
    overflow-y: scroll;
}
</style>
